import * as R from 'ramda';
import React from 'react';
import {
    List,
    Edit,
    Datagrid,
    SimpleForm,
    TextInput,
    TextField,
    EditButton,
    regex,
} from 'react-admin';



export const DeviceList = props => (
    <List {...props}>
        <Datagrid>
            <EditButton/>
            <TextField source="id" />
            <TextField source="serial_number" />
        </Datagrid>
    </List>
)


const redirectFn = (basePath, id, data) => {
    const station = R.pathOr(null, ['station'], data);
    if (!station) {
        return;
    }
    return `/stations/${station}/show/devices`;
}

const validateDeviceSN = regex(/^\d{4}-\d{5,6}$/, 'Must be a valid device number');

export const DeviceEdit = props => (
    <Edit {...props}>
        <SimpleForm redirect={redirectFn}>
            <TextInput source='serial_number' validate={validateDeviceSN}/>
        </SimpleForm>
    </Edit>
)


